import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import SignupProgress from "../../Components/SignupProgress";
import WaistModal from "../../modals/WaistModal";
import { images } from "../../Assets/images";
import Select from "react-select";
import moment from "moment-timezone";

const CreateAccountScreen3 = () => {
  const {
    signupData,
    updateSignupData,
    createAccountScreenThree,
    translatedLabels,
    logoUrl,
    getTimeZone,
    timeZone
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;
  const [selectedTimeZone, setSelectedTimeZone] = useState(null);
  const [diabetesYesNo, setDiabetesYesNo] = useState(() => {
    if (signupData?.diabetes === "No") return "2";
    if (
      signupData?.diabetes === "Type 1" ||
      signupData?.diabetes === "Type 2" ||
      signupData?.diabetes === "Not Sure"
    )
      return "1";
    return "";
  });

  const [diabetesType, setDiabetesType] = useState(
    signupData?.diabetes === "Type 1"
      ? "Type 1"
      : signupData?.diabetes === "Type 2"
        ? "Type 2"
        : signupData?.diabetes === "Not Sure"
          ? "Not Sure"
          : ""
  );
  const [showWaistModal, setShowWaistModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    createAccountScreenThree();
  };

  const TIMEZONE_MAP = {
    "Asia/Culcutta": "Asia/Kolkata",
    "Asia/Calcutta": "Asia/Kolkata",
    "America/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "America/Caracas": "America/Caracas",
    "America/La_Paz": "America/La_Paz",
    "America/Manaus": "America/Manaus",
    "America/Argentina/Buenos_Aires": "America/Argentina/Buenos_Aires",
    "Pacific/Samoa": "Pacific/Pago_Pago",
    "Pacific/Yap": "Pacific/Chuuk",
    "Pacific/Truk": "Pacific/Chuuk",
    "Pacific/Ponape": "Pacific/Pohnpei",
    "Etc/UTC": "Etc/UTC"
  };

  function normalizeTimezone(timezone) {
    return TIMEZONE_MAP[timezone] || timezone;
  }

  useEffect(() => {
    getTimeZone();
    const userTimeZone = moment?.tz?.guess();
    const normalizedTimeZone = normalizeTimezone(userTimeZone);
    setSelectedTimeZone(normalizedTimeZone);
    updateSignupData("time_zone", normalizedTimeZone);
  }, [getTimeZone]);


  return (
    <>
      <section id="createAccountPage" className="login-section-bg">
        <div className="container-main">
          <div className="d-flex justify-content-center">
            <div className="app-logo">
              <img
                src={logoUrl || images.appLogo}
                alt="app-logo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = images.appLogo;
                }}
              />
            </div>
          </div>
          <SignupProgress currentStep={3} />
          <h3 className="mb-4 text-center">
            {authLabel?.create_new_account?.label_value || "Create account"}
          </h3>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <label className="form-label">
                {authLabel?.waist_circumference?.label_value ||
                  "Waist Circumference"}{" "}
                <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_value_in_cm?.label_value || "Enter value"
                }
                value={
                  signupData.waistCircumference && signupData.waistUnit
                    ? `${signupData.waistCircumference}\u00A0\u00A0${signupData.waistUnit}`
                    : ""
                }
                readOnly
                onClick={() => setShowWaistModal(true)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="form-label">
                  {authLabel?.time_zone?.label_value || "TimeZone"}
                </label>
                <Select
                  options={timeZone?.map((item) => ({
                    value: item.zone_name,
                    label: item.zone_name,
                  }))}
                  placeholder={authLabel?.select_time_zone?.label_value || "Select Timezone"}
                  value={
                    selectedTimeZone
                      ? { value: selectedTimeZone, label: selectedTimeZone }
                      : ''
                  }
                  onChange={(option) => {
                    setSelectedTimeZone(option.value);
                    updateSignupData("time_zone", option.value);
                  }}
                />
              </div>
            </div>

            <div className="d-flex justify-content-between gap-3 mb-3">
              <div className="w-50">
                <label className="form-label">
                  {authLabel?.diabetes?.label_value || "Diabetes"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={diabetesYesNo}
                  onChange={(e) => {
                    const value = e.target.value;
                    setDiabetesYesNo(value);

                    if (value === "2") {
                      setDiabetesType("");
                      updateSignupData("diabetes", "No");
                    } else {
                      updateSignupData("diabetes", "");
                    }
                  }}
                >
                  <option value="" disabled>
                    {authLabel?.select?.label_value || "Select"}
                  </option>
                  <option value="1">
                    {authLabel?.yes?.label_value || "Yes"}
                  </option>
                  <option value="2">
                    {authLabel?.no?.label_value || "No"}
                  </option>
                </select>
              </div>

              <div className="w-50">
                <label className="form-label">
                  {authLabel?.hypertension?.label_value || "Hypertension"}{" "}
                  <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={signupData?.hypertension}
                  onChange={(e) =>
                    updateSignupData("hypertension", e.target.value)
                  }
                >
                  <option value="" disabled>
                    {authLabel?.select?.label_value || "Select"}
                  </option>
                  <option value="Yes">
                    {authLabel?.yes?.label_value || "Yes"}
                  </option>
                  <option value="No">
                    {authLabel?.no?.label_value || "No"}
                  </option>
                </select>
              </div>
            </div>

            {diabetesYesNo === "1" && (
              <div className="mb-2">
                <label className="form-label mb-0">
                  {authLabel?.diabetes_type?.label_value || "Diabetes Type "}{" "}
                  <span className="text-danger">*</span>
                </label>
                <div className="d-flex gap-4 align-items-center mt-1">
                  <div className="custom-checkbox form-check p-0">
                    <input
                      type="radio"
                      id="type1"
                      value="Type 1"
                      name="diabetesType"
                      checked={diabetesType === "Type 1"}
                      onChange={(e) => {
                        setDiabetesType(e.target.value);
                        updateSignupData("diabetes", e.target.value);
                      }}
                    />
                    <label
                      className="custom-label fw-semibold mb-0"
                      htmlFor="type1"
                    >
                      {authLabel?.type_1?.label_value || "Type 1"}
                    </label>
                  </div>

                  <div className="custom-checkbox form-check p-0">
                    <input
                      type="radio"
                      id="type2"
                      value="Type 2"
                      name="diabetesType"
                      checked={diabetesType === "Type 2"}
                      onChange={(e) => {
                        setDiabetesType(e.target.value);
                        updateSignupData("diabetes", e.target.value);
                      }}
                    />
                    <label
                      className="custom-label fw-semibold mb-0"
                      htmlFor="type2"
                    >
                      {authLabel?.type_2?.label_value || "Type 2"}
                    </label>
                  </div>

                  <div className="custom-checkbox form-check p-0">
                    <input
                      type="radio"
                      id="notSure"
                      value="Not Sure"
                      name="diabetesType"
                      checked={diabetesType === "Not Sure"}
                      onChange={(e) => {
                        setDiabetesType(e.target.value);
                        updateSignupData("diabetes", e.target.value);
                      }}
                    />
                    <label
                      className="custom-label fw-semibold mb-0"
                      htmlFor="notSure"
                    >
                      {authLabel?.not_sure?.label_value || "Not Sure"}
                    </label>
                  </div>
                </div>
              </div>
            )}

            <div className="d-flex flex-column align-items-baseline">
              <label className="form-label mb-0">
                {authLabel?.smoking?.label_value || "Smoking"}{" "}
                <span className="text-danger">*</span>
              </label>
              <div className="d-flex gap-4 align-items-center ms-2">
                <div className="custom-checkbox form-check p-0 m-0">
                  <input
                    type="radio"
                    id="smokingYes"
                    value="Yes"
                    name="smoking"
                    checked={signupData?.smoking === "Yes"}
                    onChange={(e) =>
                      updateSignupData("smoking", e.target.value)
                    }
                  />
                  <label
                    className="custom-label fw-semibold mb-0"
                    htmlFor="smokingYes"
                  >
                    {authLabel?.yes?.label_value || "Yes"}
                  </label>
                </div>
                <div className="custom-checkbox form-check p-0 m-0">
                  <input
                    type="radio"
                    id="smokingNo"
                    value="No"
                    name="smoking"
                    checked={signupData?.smoking === "No"}
                    onChange={(e) =>
                      updateSignupData("smoking", e.target.value)
                    }
                  />
                  <label
                    className="custom-label fw-semibold mb-0"
                    htmlFor="smokingNo"
                  >
                    {authLabel?.no?.label_value || "No"}
                  </label>
                </div>
              </div>
            </div>

            <div className="mt-4 text-center">
              <button className="btn btn-primary">
                {authLabel?.next?.label_value || "Next"}
              </button>
            </div>
          </form>
        </div>
      </section>
      <WaistModal
        show={showWaistModal}
        onClose={() => setShowWaistModal(false)}
        initialWaist={signupData.waistCircumference}
        initialUnit={signupData.waistUnit}
        onSave={({ waist_circumference, waistUnit }) => {
          updateSignupData("waistCircumference", waist_circumference);
          updateSignupData("waistUnit", waistUnit);
          setShowWaistModal(false);
        }}
      />
    </>
  );
};

export default CreateAccountScreen3;
